import React from 'react'

const SupportEmail = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
    >
      <g clipPath="url(#clip0_2389_59348)">
        <path
          d="M20.6668 5.49984C20.6668 4.4915 19.8418 3.6665 18.8335 3.6665H4.16683C3.1585 3.6665 2.3335 4.4915 2.3335 5.49984V16.4998C2.3335 17.5082 3.1585 18.3332 4.16683 18.3332H18.8335C19.8418 18.3332 20.6668 17.5082 20.6668 16.4998V5.49984ZM18.8335 5.49984L11.5002 10.0832L4.16683 5.49984H18.8335ZM18.8335 16.4998H4.16683V7.33317L11.5002 11.9165L18.8335 7.33317V16.4998Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2389_59348">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SupportEmail
